import { useState, useMemo } from 'react'
import { Box, Button, Switch, Tooltip } from '@mui/material'
import { LoadingButton } from '@mui/lab'
import InfoIcon from '@mui/icons-material/Info'
import { useTranslation } from 'react-i18next'

const renderTooltip = (title) => (
  <Tooltip title={title}>
    <Button>
      <InfoIcon className="security-info-icon" />
    </Button>
  </Tooltip>
)

const KybRiskMatrixSettings = ({
  riskMatrixSkipNoDataFound,
  runRiskMatrixOnUpdate,
  enableKybChecksFromKycToKyb,
  showEnableKybChecksFromKycToKyb,
  setRiskMatrixSettings,
  isLoading,
}) => {
  const { t } = useTranslation(['common', 'messages'])
  const [currentRiskMatrixSkipNoDataFound, setCurrentRiskMatrixSkipNoDataFound] = useState(riskMatrixSkipNoDataFound)
  const [currentRunRiskMatrixOnUpdate, setCurrentRunRiskMatrixOnUpdate] = useState(runRiskMatrixOnUpdate)
  const [currentEnableKybChecksFromKycToKyb, setCurrentEnableKybChecksFromKycToKyb] =
    useState(enableKybChecksFromKycToKyb)

  const isDirty = useMemo(() => {
    return (
      currentRiskMatrixSkipNoDataFound !== riskMatrixSkipNoDataFound ||
      currentRunRiskMatrixOnUpdate !== runRiskMatrixOnUpdate ||
      currentEnableKybChecksFromKycToKyb !== enableKybChecksFromKycToKyb
    )
  }, [
    currentRiskMatrixSkipNoDataFound,
    currentRunRiskMatrixOnUpdate,
    currentEnableKybChecksFromKycToKyb,
    currentEnableKybChecksFromKycToKyb,
    riskMatrixSkipNoDataFound,
    runRiskMatrixOnUpdate,
    enableKybChecksFromKycToKyb,
  ])

  const handleSave = () => {
    setRiskMatrixSettings({
      riskMatrixSkipNoDataFound: currentRiskMatrixSkipNoDataFound,
      runRiskMatrixOnUpdate: currentRunRiskMatrixOnUpdate,
      enableKybChecksFromKycToKyb: currentEnableKybChecksFromKycToKyb,
    })
  }

  return (
    <Box>
      <Box display="flex" gap="36px">
        <Box display="flex" alignItems="center">
          <p>{t('messages:kyb.settings.riskMatrixSkipNoDataFound')}</p>
          <Box className="security-flex-label">
            {renderTooltip(
              <Box className="back-tip">
                <label className="security-items-info" color="inherit">
                  {t('messages:kyb.settings.riskMatrixSkipNoDataFound.tooltip')}
                </label>
              </Box>,
            )}
            <Switch
              color="secondary"
              onChange={(e) => setCurrentRiskMatrixSkipNoDataFound(e.target.checked)}
              checked={currentRiskMatrixSkipNoDataFound}
            />
          </Box>
        </Box>
        <Box display="flex" alignItems="center">
          <p>{t('messages:kyb.settings.runRiskMatrixOnUpdate')}</p>
          <Box className="security-flex-label">
            {renderTooltip(
              <Box className="back-tip">
                <label className="security-items-info" color="inherit">
                  {t('messages:kyb.settings.runRiskMatrixOnUpdate.tooltip')}
                </label>
              </Box>,
            )}
            <Switch
              color="secondary"
              onChange={(e) => setCurrentRunRiskMatrixOnUpdate(e.target.checked)}
              checked={currentRunRiskMatrixOnUpdate}
            />
          </Box>
        </Box>
        {showEnableKybChecksFromKycToKyb && (
          <Box display="flex" alignItems="center">
            <p>{t('messages:kyb.settings.enableKybChecksFromKycToKyb')}</p>
            <Box className="security-flex-label">
              {renderTooltip(
                <Box className="back-tip">
                  <label className="security-items-info" color="inherit">
                    {t('messages:kyb.settings.enableKybChecksFromKycToKyb.tooltip')}
                  </label>
                </Box>,
              )}
              <Switch
                color="secondary"
                onChange={(e) => setCurrentEnableKybChecksFromKycToKyb(e.target.checked)}
                checked={currentEnableKybChecksFromKycToKyb}
              />
            </Box>
          </Box>
        )}
      </Box>
      <Box display="flex" justifyContent="flex-end">
        <LoadingButton variant="contained" onClick={handleSave} disabled={!isDirty || isLoading} loading={isLoading}>
          {t('common:save')}
        </LoadingButton>
      </Box>
    </Box>
  )
}

export default KybRiskMatrixSettings
